/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

const STORAGE_KEY = "IsShowGanttView";

export const setShowGanttViewToLocalStore = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
};

export const getShowGanttViewFromLocalStore = () => {
    let value = null;
    if (STORAGE_KEY in localStorage) {
        value = JSON.parse(localStorage.getItem(STORAGE_KEY));
    }
    return value;
};
